import React, { useState } from "react";
import "./PlanTable.scss";
import Button from "../../../../FTTX/component/Button";

const PlanTable = ({ bundles, translation, sendSelectedPlan }) => {
  const [selectedBundle, setSelectedBundle] = useState(null);
  const handleRadioChange = (bundle) => {
    setSelectedBundle(bundle);
    sendSelectedPlan(bundle);
  };


  return (
    
    <div className="buybundle_table-x">
      <div className="buybundle_table">
        {!!bundles?.length && (
          <div className="buybundle-head">
            <div className="buybundle_cell">{translation?.bundles}</div>
            <div className="buybundle_cell">{translation?.resources}</div>
            <div className="buybundle_cell">{translation?.bundleValidity}</div>
            <div className="buybundle_cell">{translation?.price}</div>
            <div className="buybundle_cell"></div>
          </div>
        )}
        {!!bundles?.length &&
          bundles.map((bundle) => (
            <div
              className="buybundle_row"
              onClick={() => handleRadioChange(bundle)}
              key={bundle.name}
            >
              <div className="buybundle_cell"> <div className="bundle_dl">{bundle.description}</div></div>
              <div className="buybundle_cell">
                <div className="bundle_dl">
                  {bundle.data} {bundle.dataUnit}
                </div>
              </div>
              <div className="buybundle_cell">
                <div className="bundle_dl">
                  {bundle.validity} {bundle.validityUnit}
                </div>
              </div>
              <div className="buybundle_cell">
                <div className="bundle_currency">
                  <span>{bundle.currency} { }</span>
                  {bundle.amount}
                </div>
              </div>
              <div className="buybundle_cell">
                <div className="select-btn">
                <Button text={translation?.select} btnType="danger" callBack={() => handleRadioChange(bundle)}/>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default PlanTable;